import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// v407.8 — product-list ordering (owner directive): names that start with a
// digit (e.g. "5-Amino-1MQ 50mg") sort AFTER lettered names, then A→Z.
export function compareProductNames(a, b) {
  const an = a || "";
  const bn = b || "";
  const digitLast = (/^\d/.test(an) ? 1 : 0) - (/^\d/.test(bn) ? 1 : 0);
  return digitLast || an.localeCompare(bn);
}

export function byProductName(a, b) {
  return compareProductNames(a?.name, b?.name);
}

// v414.16 — recipe conversions can leave fractional vial counts (1 jar uses
// 1.43 GHK-Cu). Trim float drift for display: 45.570000000001 -> 45.57.
export function fmtQty(n) {
  const v = Number(n);
  if (!Number.isFinite(v)) return n;
  return Number.isInteger(v) ? v : +v.toFixed(2);
}
